/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_login_validation_password_required = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password is required`)
};

const zh_hans1_login_validation_password_required = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`密码不能为空`)
};

const zh_hant1_login_validation_password_required = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`請輸入密碼`)
};

const fr_login_validation_password_required = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le mot de passe est requis`)
};

const de_login_validation_password_required = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwort ist erforderlich`)
};

const ja_login_validation_password_required = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスワードは必須です`)
};

const ko_login_validation_password_required = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`비밀번호를 입력하세요`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const login_validation_password_required = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.login_validation_password_required(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("login_validation_password_required", locale)
	if (locale === "en") return en_login_validation_password_required(inputs)
	if (locale === "zh-Hans") return zh_hans1_login_validation_password_required(inputs)
	if (locale === "zh-Hant") return zh_hant1_login_validation_password_required(inputs)
	if (locale === "fr") return fr_login_validation_password_required(inputs)
	if (locale === "de") return de_login_validation_password_required(inputs)
	if (locale === "ja") return ja_login_validation_password_required(inputs)
	return ko_login_validation_password_required(inputs)
};